import { ModuleType } from "../../queryKeyFactory";

export const billCorrectionKeys = {
    billSearch: (
        search: string,
        page: number
      ): [ModuleType, "bill-search", string, number] => [
        "mx",
        "bill-search",
        search,
        page,
      ],
      billCorrectionTypes: (): [ModuleType, 'correction-types'] => ['bx', 'correction-types'],
      billCorrectionDetails: (billId): [ModuleType, 'correction-details', number] => ['bx', 'correction-details', billId],
      impactAnalysisDetails: (correctionId): [ModuleType, 'corrected-details', number] => ['bx', 'corrected-details', correctionId],
      billTemplates: (): [ModuleType, 'bill-templates'] => ['bx', 'bill-templates'],
      billPreview: (correctionId): [ModuleType, 'bill-preview', any] => ['bx', 'bill-preview', correctionId],
      billCorrectionList: (search, page): [ModuleType, 'bill-correction-list', string, number] => ['bx', 'bill-correction-list', search, page],
      billCorrectedDetails: (correctionId): [ModuleType, 'corrected-detail-view', string] => ['bx', 'corrected-detail-view', correctionId],


}